<template>
  <Day day="06.12.2025">
    <div slot="page-content">
      <h3>Kaja the Rednose Reindeer</h3>
      <p>
      <img src="@/assets/day6.jpeg"/>
      </p>
    </div>
  </Day>
</template>

<script>
import Day from '../Day.vue'

export default {
  name: 'Day06',
  components: {
    Day
  }
}
</script>
